<template>
    <!--
            作者：kmdshop
            时间：2019-10-25
            描述：会员-用户列表
        -->
    <div class="user">
      <!--搜索表单-->
      <div class="common-seach-wrap">
        <el-form size="small" :inline="true" :model="formInline" class="demo-form-inline">
          <el-form-item label="用户">
            <el-input v-model="formInline.search" placeholder="用户ID或会员编号或手机号或昵称" style="width:220px"></el-input>
          </el-form-item>
          <el-form-item label="会员等级">
            <el-select v-model="formInline.grade_id" placeholder="请选择">
              <el-option label="全部" value="0"></el-option>
              <el-option v-for="(item, index) in gradeList" :key="index" :label="item.name" :value="item.grade_id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="创建时间">
            <div class="block">
              <span class="demonstration"></span>
              <el-date-picker v-model="formInline.reg_date" type="daterange" value-format="yyyy-MM-dd" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
            </div>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" @click="onSubmit">查询</el-button>

            <el-button size="small" type="success" @click="batchExportAll">导出</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div>

      </div>
  
      <!--内容-->
      <div class="product-content">
        <div class="table-wrap">
          <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading" @selection-change="handleSelectionChange">
            <el-table-column type="selection" width="45"></el-table-column>
            <el-table-column prop="user_id" label="ID" width="80"></el-table-column>
 
            <el-table-column prop="avatarUrl" label="微信头像" width="80">
              <template slot-scope="scope">
                <div v-if="scope.row.user.avatarUrl">
                  <img :src="scope.row.user.avatarUrl" width="30px" height="30px"/>
                </div>
              </template>
            </el-table-column>
    
            <el-table-column prop="" label="会员">
              <template slot-scope="scope">
                <div>用户ID：{{ scope.row.user.user_id }}</div>
                <div>等级：{{ scope.row.user.grade_name }}</div>
                <div>昵称：{{ scope.row.user.nickName }}</div>
                <div>手机号：{{ scope.row.user.mobile }}</div>
              </template>
            </el-table-column>
            <el-table-column prop="remark" label="相关订单">
                <template slot-scope="scope">
                    <div @click="orderClick(scope.row.order_params)" style="color: blue;">{{ scope.row.order_params.order_no }}</div>
           
              </template>
            </el-table-column>
            <el-table-column prop="remark" label="商品" width="250">
              <template slot-scope="scope">
                <div v-if="scope.row.order_params.p_name.length > 0" v-for="(item,index) in scope.row.order_params.p_name" :key="index">
                    商品名称：{{ item.product_name }} <span style="margin-left: 10px;">商品数量：{{ item.num }} </span>
                </div>  
                <div v-if="scope.row.order_params.p_name.length <= 0" >
                  商品名称：{{ scope.row.order_params.product_name }} <span style="margin-left: 10px;">商品数量：{{ scope.row.order_params.num }} </span>
                </div>    
              </template>
            </el-table-column>
            <el-table-column prop="order_params.pay_price" label="交易金额"></el-table-column>

            <el-table-column prop="order_params.nick_name" label="购买者"></el-table-column>

          

            <!-- <el-table-column prop="remark" label="返佣类型"></el-table-column> -->
            <el-table-column prop="price" label="返佣金额"></el-table-column>

            <!-- <el-table-column prop="is_settled" label="是否结算">
                <template slot-scope="scope">
                    <div v-if="scope.row.is_settled == 0">未结算</div>
                    <div v-if="scope.row.is_settled == 1">已结算</div>
              </template>
            </el-table-column>
            <el-table-column prop="settled_time" label="结算时间"></el-table-column>
        
   -->
            <el-table-column prop="create_time" label="创建时间" width="140"></el-table-column>
          </el-table>
        </div>
  
        <!--分页-->
        <div class="pagination">
          <el-pagination 
          @size-change="handleSizeChange" 
          @current-change="handleCurrentChange" 
          background :current-page="curPage" 
          :page-sizes="[20, 100,500, 1000]"
          layout="total,sizes, prev, pager, next, jumper" 
          :total="totalDataNumber"></el-pagination>
        </div>
      </div>
  
   
    </div>
  </template>
  
  <script>
  import UserApi from '@/api/user.js';
  import qs from 'qs';
  export default {
    components: {

    },
    data() {
      return {
        /*是否加载完成*/
        loading: true,
        /*列表数据*/
        tableData: [],
        /*一页多少条*/
        pageSize: 20,
        /*一共多少条数据*/
        totalDataNumber: 0,
        /*当前是第几页*/
        curPage: 1,
        /*横向表单数据模型*/
        formInline: {
          search: '',
          grade_id: '',
          reg_date: '',
          agent_id: '',
        },
        /*是否打开添加弹窗*/
        open_add: false,
        open_add1: false,
        /*是否打开批量修改等级弹窗*/
        open_changegrade: false,
        /*是否打开编辑弹窗*/
        open_edit: false,
        open_kmd: false,
        open_relation: false,
        /*当前编辑的对象*/
        userModel: {
          // 会员到期时间设置
          expire_date_text: '',
        },
        /*等级*/
        gradeList: [],
        /*选中的*/
        multipleSelection: [],
        /*选择的会员列表*/
        select_list: [],
        app_id: 10001,
      };
    },
    created() {
      /*获取列表*/
      this.getTableList()
    },
  
    methods: {
      serviceClick(row){//服务项目详情
        let self = this;
        let params = row.user_id;
        self.$router.push({
          path: '/user/user/detail',
          query: {
            user_id: params,
            activeName:"remark"
          }
        });
      },
      childClick(row){//服务项目详情
        let self = this;
        let params = row.user_id;
        self.$router.push({
          path: '/user/userstructure/userstructure',
          query: {
            user_id: params,
          }
        });
      },
      orderClick(row){
        this.$router.push({
        path: "/order/order/index",
        query: {
            order_no:row.order_no
        }
      });
      },

      /*选择第几页*/
      handleCurrentChange(val) {
        this.curPage = val
        this.getTableList()
      },
      /*每页多少条*/
      handleSizeChange(val) {
        this.curPage = 1
        this.pageSize = val
        this.getTableList()
      },
  
      onBeforeUploadImage(file) {
        var fileType = file.name.substring(file.name.lastIndexOf('.') + 1)
        fileType = fileType.toLowerCase();
        const isEXCEL = (fileType === 'xlsx' || fileType === 'xls');
        const isLt10M = file.size / 1024 / 1024 < 10;
        if (!isEXCEL) {
          this.$message.error('上传文件只能是excel格式!');
        }
        if (!isLt10M) {
          this.$message.error('上传文件大小不能超过 10MB!');
        }
        return isEXCEL && isLt10M;
      },
  
        onimport(param){
          let self = this;
          self.$confirm('是否导入旧成员', '提示', {
            type: 'warning'
          }).then(() => {
            const loading = this.$loading({
              lock: true,
              text: '正在上传,请等待',
              spinner: 'el-icon-loading',
              background: 'rgba(0, 0, 0, 0.7)'
            });
            let formData = new FormData();
            formData.append('iFile', param.file);
    
            UserApi.importOldUsers(formData)
              .then(response => {
                loading.close();
                if(response.code == 1){
                  self.getTableList();
                  self.$message({
                  message: response.msg,
                  type: 'success'
                });
                }else{
                  self.$message({
                  message: response.msg,
                  type: 'error'
                });
                }
                
                
              })
              .catch(response => {
                loading.close();
                self.$message({
                  message: '导入失败',
                  type: 'warning'
                });
              });
          });
      },
      /*获取列表*/
      getTableList() {
        let self = this
        self.loading = true
        let Params = self.formInline
        Params.page = self.curPage
        Params.list_rows = self.pageSize
        UserApi.log(Params, true)
          .then(data => {
            self.loading = false
            self.tableData = data.data.list.data
            self.totalDataNumber = data.data.list.total
            self.gradeList = data.data.grade
          })
          .catch(error => {
            self.loading = false
          });
      },
  
      viewUser(user_id){
        this.curPage = 1;;
        this.pageSize = 20;
        this.tableData = [];
        this.formInline.search = user_id;
        this.formInline.agent_id = '';
        this.getTableList();
      },
  
      viewFirstUser(user_id){
        this.curPage = 1;;
        this.pageSize = 20;
        this.tableData = [];
        this.formInline.search = '';
        this.formInline.agent_id = user_id;
        this.getTableList();
      },
  
      /*搜索查询*/
      onSubmit() {
        let self = this
        self.curPage = 1
        self.getTableList()
      },
  
      /*打开添加*/
      addClick(item) {
        this.userModel = item;
        this.open_add = true;
      },
  
      /*打开添加客户*/
      addClick1() {
        this.open_add1 = true;
      },
      /*打开批量修改等级*/
      ChangeGrade() {
        let user_ids = [];
        let params = this.multipleSelection;
        params.forEach((param) => {
          user_ids.push(param.user_id);
        })
        user_ids = user_ids.join(',');
        console.log(user_ids);
        if (user_ids == '') {
          this.$message({
            message: '请选择修改等级的会员',
            type: 'error'
          });
        } else {
          this.open_changegrade = true;
          this.select_list = user_ids;
        }
  
      },
  
      /*关闭添加*/
      closeAdd(e) {
        this.open_add1 = false;
        if (e.type == 'success') {
          this.getTableList();
        }
      },
      /*关闭批量修改等级*/
      closeChangeggrade(e) {
        this.open_changegrade = false;
        if (e.type == 'success') {
          this.getTableList();
        }
      },
  
      /* 编辑会员信息 */
      editAdd(item) {
        this.userModel = item;
        this.open_kmd = true;
      },
      /*打开编辑*/
      editClick(item) {
        this.userModel = item;
        this.open_edit = true;
      },
      /*选择会员*/
      handleSelectionChange(e) {
        this.multipleSelection = e;
      },
  
      /* 修改会员关系 */
      relation(item) {
        this.userModel = item;
        this.open_relation = true;
      },
  
      /*关闭弹窗*/
      closeDialogFunc(e, f) {
        if (f == 'add') {
          this.open_add = e.openDialog;
          if (e.type == 'success') {
            this.getTableList();
          }
        }
        if (f == 'edit') {
          this.open_edit = e.openDialog;
          if (e.type == 'success') {
            this.getTableList();
          }
        }
        if (f == 'kmd') {
          this.open_kmd = e.openDialog;
          if (e.type == 'success') {
            this.getTableList();
          }
        }
        if (f == 'relation') {
          this.open_relation = e.openDialog;
          if (e.type == 'success') {
            this.getTableList();
          }
        }
      },
  
      /*删除用户*/
      deleteClick(row) {
        let self = this;
        self
          .$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
          .then(() => {
            self.loading = true
            UserApi.deleteuser(
              {
                user_id: row.user_id
              },
              true
            )
              .then(data => {
                self.loading = false
                if (data.code == 1) {
                  self.$message({
                    message: '会员删除成功',
                    type: 'success'
                  });
                  self.getTableList()
                } else {
                  self.loading = false
                }
              })
              .catch(error => {
                self.loading = false
              });
          })
          .catch(() => {
            self.loading = false;
          });
      },
  
      /*批量禁用用戶*/
      batchForbidden() {
        let user_ids = [];
        let params = this.multipleSelection;
        params.forEach((param) => {
          user_ids.push(param.user_id);
        })
        user_ids = user_ids.join(',');
        console.log(user_ids);
        if (user_ids == '') {
          this.$message({
            message: '请选择要禁用的用户',
            type: 'error'
          });
        } else {
          UserApi.UserForbidden({
            user_ids: user_ids
          }).then(data => {
            this.$message({
              message: '批量禁用用户成功',
              type: 'success'
            });
            this.getTableList();
          });
        }
      },
      /*批量解封用戶*/
      batchRelieve() {
        let user_ids = [];
        let params = this.multipleSelection;
        params.forEach((param) => {
          user_ids.push(param.user_id);
        })
        user_ids = user_ids.join(',');
        console.log(user_ids);
        if (user_ids == '') {
          this.$message({
            message: '请选择要禁解封的用户',
            type: 'error'
          });
        } else {
          UserApi.batchRelieve({
            user_ids: user_ids
          }).then(data => {
            this.$message({
              message: '批量解封用户成功',
              type: 'success'
            });
            this.getTableList();
          });
        }
  
      },
      batchExportAll(){//导出全部
        var parmasa =  this.formInline?this.formInline:{};
        parmasa["list_rows"] = this.pageSize
        parmasa["page"] = this.curPage
        let baseUrl = window.location.protocol + '//' + window.location.host;
        window.location.href = baseUrl + '/index.php/shop/product.product/exportUserLog?' + 
        qs.stringify(parmasa)+'&user_ids='+""+"&atype=all";
          
      },
      batchExport(){//批量导出
          // 勾选需要导出的数据
          let user_ids = [];
        let params = this.multipleSelection;
        console.log("params",params)
        params.forEach((param)=>{
          user_ids.push(param.user_id);
        })
        user_ids = user_ids.join(',');
        // 筛选条件
        // 商品状态
        var parmasa =  this.searchForm?this.searchForm:{};
        console.log("parmasa",parmasa)
        parmasa["list_rows"] = this.pageSize
        parmasa["page"] = this.curPage
        console.log("user_ids",user_ids)
        if(user_ids.length > 0){
          // console.log(this.searchForm)
          let baseUrl = window.location.protocol + '//' + window.location.host;
          window.location.href = baseUrl + '/index.php/shop/product.product/exportUser?' + 
          qs.stringify(parmasa)+'&user_ids='+user_ids+"&atype=cond";
          
        }else{
          this.$message({
              message: '请选择要导出的数据',
              type: 'error'
            });
        }
     
  
      },
  
    }
  };
  </script>
  <style></style>
  


// WEBPACK FOOTER //
// src/views/user/log/index.vue